/*
 * $Id:: index.js 2020/11/12 06:07 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import NoImageIcon from '../../assets/images/no_image.svg';
import { t } from '../../providers/TranslationProvider';

const useStyles = makeStyles((theme) => ({
    noImageappImageGrid: {
        background: '#F9FAFB',
        backgroundSize: '20px 20px',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    noImageappImage: {
        width: '164px',
        height: '100%',
        display: 'flex',
        background: '#F9FAFB',
        alignItems: 'center',
        backgroundSize: '20px 20px',
        justifyContent: 'center',
        padding: '0px 12px',
    },
    noImageIcon: {},
    noImageBorderappImage: {
        border: '1px solid #D9D9D9',
        boxSizing: 'border-box',
        borderRadius: '2px',
        padding: '1px 4px',
        textAlign: 'center',
        fontSize: '0.75rem',
        background: 'unset',
        '& span': {
            color: theme.palette.text.chipgrey,
            letterSpacing: '-0.2px',
            fontStyle: 'normal',
            fontWeight: 'normal',
            lineHeight: '142%',
        },
    },
    noImageBorderappImageGrid: {
        border: '1px solid #D9D9D9',
        boxSizing: 'border-box',
        borderRadius: '2px',
        padding: '8px 10px',
        textAlign: 'center',
        fontSize: '0.875rem',
        '& span': {
            color: theme.palette.text.chipgrey,
            letterSpacing: '-0.2px',
            fontStyle: 'normal',
            fontWeight: 'normal',
            lineHeight: '142%',
            margin: '0 8px',
        },
    },
}));

const NoImage = ({ imageClass }) => {
    const classes = useStyles();
    return (
        <div className={classes[`noImage${imageClass}`]}>
            <div className={classes[`noImageBorder${imageClass}`]}>
                {imageClass === 'appImageGrid' && <img src={NoImageIcon} alt={t('no.image.available.text')} />}
                <span className={classes[imageClass]}>{t('no.image.available.text')}</span>
            </div>
        </div>
    );
};

export default NoImage;
